<template>
  <div class="bill-ratio-setting">
    <el-dialog
      title="分账比例配置"
      width="560px"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        ref="formEl"
        :model="form"
        :rules="rules"
        label-width="120px"
        size="small"
      >
        <el-form-item label="平台方：">
          <span class="value-text">北京新广汇贤人力资源管理有限责任公司</span>
        </el-form-item>
        <el-form-item label="分账比例：" prop="homeRate">
          <el-input v-model.trim="form.homeRate" placeholder="请填写分账比例" style="width: 320px" @input="form.homeRate = getMoney($event)">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
        <el-form-item label="所属代理商：" prop="agentId">
          <span class="value-text">{{ form.agentName }}</span>
        </el-form-item>
        <el-form-item label="分账比例：" prop="agentRate">
          <el-input v-model.trim="form.agentRate" placeholder="请填写分账比例" style="width: 320px" @input="form.agentRate = getMoney($event)">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
        <template v-if="type === 2">
          <el-form-item label="所属分销商：" prop="distributionId">
            <span class="value-text">{{ form.distributionName }}</span>
          </el-form-item>
          <el-form-item label="分账比例：" prop="distributionRate">
            <el-input v-model.trim="form.distributionRate" placeholder="请填写分账比例" style="width: 320px" @input="form.distributionRate = getMoney($event)">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </template>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">关 闭</el-button>
        <el-button :loading="saveing" size="small" type="primary" @click="handleAffirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  setAccountRate
} from '@/api/organization'
import { add, processing } from '@/utils/handle.js'

export default {
  name: 'BillRatioSetting',

  props: {
    type: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      dialogVisible: false,
      form: {
        homeRate: '',
        agentId: '',
        agentName: '',
        agentRate: '',
        distributionId: '',
        distributionName: '',
        distributionRate: '',
      },
      rules: {
        homeRate: [
          { required: true, message: "请填写分账比例!", trigger: "blur" },
        ],
        agentRate: [
          { required: true, message: "请填写分账比例!", trigger: "blur" },
        ],
        distributionRate: [
          { required: true, message: "请填写分账比例!", trigger: "blur" },
        ],
      },
      saveing: false
    }
  },
  computed: {
    isComplate () {
      let c = add(this.form.homeRate, this.form.agentRate)
      if (this.type === 2) {
        c = add(c, this.form.distributionRate)
      }
      return c === 100
    }
  },
  methods: {
    init (payload) {
      this.form.homeRate = payload.homeRate
      this.form.agentId = payload.agentId
      this.form.agentName = payload.agentName
      this.form.agentRate = payload.agentRate
      if (this.type === 2) {
        this.form.distributionId = payload.distributionId
        this.form.distributionName = payload.distributionName
        this.form.distributionRate = payload.distributionRate
      }
      this.dialogVisible = true
    },
    handleAffirm () {
      this.$refs.formEl.validate(valid => {
        if (valid) {
          if (!this.isComplate) {
            this.$message.warning('分账比例之和不满足相加为100%!')
            return
          }
          this.saveing = true
          const params = {
            ...this.form,
            type: this.type
          }
          setAccountRate(processing(params)).then(({ code }) => {
            if (code === 0) {
              this.$message.success('分账比例配置成功!')
              this.$emit('refresh')
              this.handleClose()
            }
          }).finally(() => {
            this.saveing = false
          })
        }
      })
    },
    getMoney (value) {
      value = value.replace(/[^\d.]/g, "")
      value = value.replace(/\.{2,}/g, ".")
      value = value.replace( /^(-)*(\d+)\.(\d).*$/, "$1$2.$3")
      return value
    },
    handleClose () {
      this.form = this.$options.data().form
      this.$refs.formEl && this.$refs.formEl.resetFields()
      this.dialogVisible = false
    }
  }
}
</script>

<style>

</style>
